module.exports = __webpack_public_path__ + "static/img/wa-offshore-accessible-colorbar.59cb478.png";